<template>
  <div class="content">
    <base-header :choose-index="1"></base-header>
    <div class="middle_content">
      <!-- <img class="middle_content-post" ref="post" src="@@/assets/img/westa/店招/公司简介1920X900.jpg" /> -->
      <swiper ref="aboutSwiper" :options="swiperOption" class="swiper-container" :style="{'height': post_height}" v-if="show">
        <swiper-slide>
          <div class="middle_content-post1" v-bgImg="require('@@/assets/img/westa/about/bg_01.jpg')"
            :style="{'height': post_height}">
            <div class="middle_content-post1-bg-flex">
              <div class="middle_content-post1-bg-flex-text"
                v-bgImg="require('@@/assets/img/westa/about/品牌介绍_'+utils.getCookie('lang')+'.png')"></div>
              <div class="middle_content-post1-bg-flex-flex">
                <div class="middle_content-post1-bg">
                  <div class="middle_content-post1-bg-pic"
                    v-bgImg="utils.getQiniuWidthUrl(content_about_ppjs[0].ppjs_face, 558, 2, 'webp')"
                    @click="centerDialogVisible = true"></div>
                </div>
                <div class="middle_content-post1-bg5">
                  <div class="middle_content-post1-title swiper-no-swiping">{{utils.local(lang,"公司简介")}}</div>
                  <div
                    class="middle_content-post1-desc swiper-no-swiping"
                    @wheel="onDescWheel"
                    @mouseenter="onDescEnter"
                    @mouseleave="onDescLeave"
                  >
                    <div ref="descScroll" class="middle_content-post1-desc-inner">{{content_about_ppjs[0].ppjs_text}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="middle_content-post1" v-bgImg="require('@@/assets/img/westa/about/bg_02.png')"
            :style="{'height': post_height}">
            <div class="middle_content-post1-bg-flex">
              <div class="middle_content-post1-bg1-text"
                v-bgImg="require('@@/assets/img/westa/about/企业文化CULTURE_'+utils.getCookie('lang')+'.png')"></div>
              <div class="middle_content-post1-bg-flex-flex">
                <div class="middle_content-post1-bg1" v-for="(item,index) in content_about_qywh" :key="index">
                  <!-- <div
                class="middle_content-post1-bg1-pic"
                v-bgImg="require('@@/assets/img/westa/about/品牌理念.png')"
                  ></div>-->
                  <div class="middle_content-post1-bg1-pic" v-bgImg="utils.getQiniuWidthUrl(item.qywh_front_img, 318, 3, 'webp')">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="middle_content-post1" v-bgImg="require('@@/assets/img/westa/about/bg_03.png')"
            :style="{'height': post_height}">
            <div class="middle_content-post1-bg-flex">
              <div class="middle_content-post1-bg4-text"
                v-bgImg="require('@@/assets/img/westa/about/发展历程OURDEVELOPMENT_'+utils.getCookie('lang')+'.png')">
              </div>
              <div class="middle_content-post1-bg4"
                v-bgImg="utils.getQiniuWidthUrl(content_about_fzlc[chooseIndex].fzlc_img, 1200, 1, 'webp')"></div>
              <div class="middle_content-post1-time">
                <div class="middle_content-post1-time-flex" v-for="(item, index) in content_about_fzlc" :key="index">
                  <div class="middle_content-post1-time-item">
                    <div class="middle_content-post1-time-item-icon1" v-bgImg="require('@@/assets/img/westa/about/椭圆7.png')"
                      v-show="chooseIndex === index"></div>
                    <div class="middle_content-post1-time-item-icon" v-bgImg="require('@@/assets/img/westa/about/椭圆6.png')"
                      v-show="chooseIndex != index" @click="changePic(index)"></div>
                    <div :class="{'active': chooseIndex === index}">{{item.fzlc_tag}}</div>
                  </div>
                  <div class="middle_content-post1-time-line" v-if="index<fzlc_len-1"></div>
                </div>
                <!-- <div class="middle_content-post1-time-item">
                  <div
                    class="middle_content-post1-time-item-icon"
                    v-bgImg="require('@@/assets/img/westa/about/椭圆6 2.png')"
                  ></div>
                  <div>2017</div>
                </div>
                <div class="middle_content-post1-time-line"></div>
                <div class="middle_content-post1-time-item">
                  <div
                    class="middle_content-post1-time-item-icon"
                    v-bgImg="require('@@/assets/img/westa/about/椭圆6 2.png')"
                  ></div>
                  <div>2016</div>
                </div>
                <div class="middle_content-post1-time-line"></div>
                <div class="middle_content-post1-time-item">
                  <div
                    class="middle_content-post1-time-item-icon"
                    v-bgImg="require('@@/assets/img/westa/about/椭圆6 2.png')"
                  ></div>
                  <div>2015</div>
                </div>
                <div class="middle_content-post1-time-line"></div>
                <div class="middle_content-post1-time-item">
                  <div
                    class="middle_content-post1-time-item-icon"
                    v-bgImg="require('@@/assets/img/westa/about/椭圆6 2.png')"
                  ></div>
                  <div>2014</div>
                </div>
                <div class="middle_content-post1-time-line"></div>
                <div class="middle_content-post1-time-item">
                  <div
                    class="middle_content-post1-time-item-icon"
                    v-bgImg="require('@@/assets/img/westa/about/椭圆6 2.png')"
                  ></div>
                  <div>2013</div>
                </div>
                <div class="middle_content-post1-time-line"></div>
                <div class="middle_content-post1-time-item">
                  <div
                    class="middle_content-post1-time-item-icon"
                    v-bgImg="require('@@/assets/img/westa/about/椭圆6 2.png')"
                  ></div>
                  <div>2012</div>
                </div>
                <div class="middle_content-post1-time-line"></div>
                <div class="middle_content-post1-time-item">
                  <div
                    class="middle_content-post1-time-item-icon"
                    v-bgImg="require('@@/assets/img/westa/about/椭圆6 2.png')"
                  ></div>
                  <div>2009</div>
                </div>
                <div class="middle_content-post1-time-line"></div>
                <div class="middle_content-post1-time-item">
                  <div
                    class="middle_content-post1-time-item-icon"
                    v-bgImg="require('@@/assets/img/westa/about/椭圆6 2.png')"
                  ></div>
                  <div>2008</div>
                </div>
                <div class="middle_content-post1-time-line"></div>
                <div class="middle_content-post1-time-item">
                  <div
                    class="middle_content-post1-time-item-icon"
                    v-bgImg="require('@@/assets/img/westa/about/椭圆6 2.png')"
                  ></div>
                  <div>2004</div>
                </div>
                <div class="middle_content-post1-time-line"></div>
                <div class="middle_content-post1-time-item">
                  <div
                    class="middle_content-post1-time-item-icon"
                    v-bgImg="require('@@/assets/img/westa/about/椭圆6 2.png')"
                  ></div>
                  <div>2001</div>
                </div>
                <div class="middle_content-post1-time-line"></div>
                <div class="middle_content-post1-time-item">
                  <div
                    class="middle_content-post1-time-item-icon"
                    v-bgImg="require('@@/assets/img/westa/about/椭圆6 2.png')"
                  ></div>
                  <div>2000</div>
                </div>
                <div class="middle_content-post1-time-line"></div>
                <div class="middle_content-post1-time-item">
                  <div
                    class="middle_content-post1-time-item-icon"
                    v-bgImg="require('@@/assets/img/westa/about/椭圆6 2.png')"
                  ></div>
                  <div>1996</div>
                </div>
                <div class="middle_content-post1-time-line"></div>
                <div class="middle_content-post1-time-item">
                  <div
                    class="middle_content-post1-time-item-icon"
                    v-bgImg="require('@@/assets/img/westa/about/椭圆6 2.png')"
                  ></div>
                  <div>1995</div>
                </div>
                <div class="middle_content-post1-time-line"></div>
                <div class="middle_content-post1-time-item">
                  <div
                    class="middle_content-post1-time-item-icon"
                    v-bgImg="require('@@/assets/img/westa/about/椭圆6 2.png')"
                  ></div>
                  <div>1994</div>
                </div>
                <div class="middle_content-post1-time-line"></div>
                <div class="middle_content-post1-time-item">
                  <div
                    class="middle_content-post1-time-item-icon"
                    v-bgImg="require('@@/assets/img/westa/about/椭圆6 2.png')"
                  ></div>
                  <div>1993</div>
                </div>-->
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="middle_content-post1" v-bgImg="require('@@/assets/img/westa/about/bg_04.png')"
            :style="{'height': post_height}">
            <div class="middle_content-post1-bg-flex1">
              <div class="middle_content-post1-bg-flex1-flex">
                <div class="middle_content-post1-bg-flex-text1"
                  v-bgImg="require('@@/assets/img/westa/about/荣誉奖项AWARDS_'+utils.getCookie('lang')+'.png')">
                </div>
              </div>
              <swiper :options="swiperOption1">
                <swiper-slide v-for="(item, index) in content_about_ryjx" :key="index">
                  <div class="middle_content-post1-bg3" v-bgImg="utils.getQiniuWidthUrl(item, 1200, 3, 'webp')"></div>
                </swiper-slide>
                <div class="swiper-button-prev btn1" slot="button-prev" v-bgImg="require('@@/assets/img/westa/about/right.png')">
                </div>
                <div class="swiper-button-next btn2" slot="button-next" v-bgImg="require('@@/assets/img/westa/about/next.png')">
                </div>
              </swiper>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>

    <el-dialog :visible.sync="centerDialogVisible" width="880px" center v-if="show">
      <!-- <div class="dialog"> -->
      <video v-if="centerDialogVisible" width="830" height="440" controls="controls" autoplay="autoplay">
        <source :src="content_about_ppjs[0].ppjs_video" type="video/mp4" />
      </video>
      <!-- </div> -->
      <!-- <iframe frameborder="0" :src="video_link" allowfullscreen="true" class="dialog-video"></iframe> -->
    </el-dialog>
    <!-- <base-footer></base-footer> -->
  </div>
</template>

<script>
import BaseHeader from "@@/components/westa/base-header";
import BaseFooter from "@@/components/westa/base-footer";
import { log } from "util";
export default {
  data() {
    return {
      lang: "about",
      post_height: "0",
      h1: "0",
      year: [
        "2018",
        "2017",
        "2016",
        "2015",
        "2014",
        "2013",
        "2012",
        "2009",
        "2008",
        "2004",
        "2001",
        "2000",
        "1996",
        "1995",
        "1994",
        "1993"
      ],
      pic1: true,
      swiperOption: {
        direction: "vertical",
        initialSlide: 0,
        // spaceBetween: 30,
        //是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        notNextTick: true,
        slidesPerView: 1,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        mousewheel: true
      },
      swiperOption1: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      swiperOption2: {},
      content_about_ppjs: [],
      content_about_fzlc: [],
      content_about_qywh: [],
      content_about_ryjx: [],
      show: false,
      chooseIndex: 0,
      fzlc_len: 0,
      centerDialogVisible: false,
      initPage: 0,
      descScrollPaused: false,
      descScrollRunning: false,
      descScrollRaf: null,
      descScrollOffset: 0,
      descScrollRetryTimer: null,
      descScrollResumeTimer: null
    };
  },
  components: {
    BaseHeader,
    BaseFooter
  },
  created() {
    // this.init();
    let id = this.$route.query.id;
    this.initPage = id;
    if (id) {
      this.swiperOption.initialSlide = this.initPage;
    }

    this.getInfo();
  },
  mounted() {
    this.init();
    window.onresize = () => {
      this.init();
      // location.reload();
    };
  },
  beforeDestroy() {
    this.stopDescAutoScroll();
  },
  methods: {
    init() {
      this.post_height = window.innerHeight - 64 + "px";
      console.log(window.innerHeight);

      // this.middle_height = window.innerHeight;
    },
    getInfo() {
      let params = {};
      this.req
        .get(
          url_api_web_websiteContent_getWebsiteContent,
          this.qs.stringify(params)
        )
        .then(result => {
          this.content_about_ppjs = JSON.parse(
            result.website_content.content_about_ppjs
          );
          this.content_about_fzlc = JSON.parse(
            result.website_content.content_about_fzlc
          );
          this.fzlc_len = this.content_about_fzlc.length;
          this.content_about_qywh = JSON.parse(
            result.website_content.content_about_qywh
          );
          this.content_about_ryjx = JSON.parse(
            result.website_content.content_about_ryjx
          );
          this.content_about_ryjx = this.content_about_ryjx[0].ryjx_imgs.split(
            ","
          );
          this.show = true;
          this.$nextTick(() => {
            // 等 Swiper 把第一屏挂载完成后再启动
            setTimeout(() => {
              this.startDescAutoScroll();
            }, 400);
          });
        })
        .catch(error => { });
    },
    changePic(index) {
      this.chooseIndex = index;
    },
    getAboutSwiper() {
      const ref = this.$refs.aboutSwiper;
      return (ref && (ref.swiper || ref.$swiper)) || null;
    },
    getDescEls() {
      let inner = this.$refs.descScroll;
      if (Array.isArray(inner)) inner = inner[0];
      if (!inner) {
        inner = this.$el && this.$el.querySelector(".middle_content-post1-desc-inner");
      }
      const wrap = inner && inner.parentElement;
      return { inner, wrap };
    },
    setPageMousewheel(enabled) {
      const swiper = this.getAboutSwiper();
      if (!swiper) return;
      // Swiper 4: enable/disableMousewheelControl；Swiper 5+: mousewheel.enable/disable
      if (enabled) {
        if (swiper.enableMousewheelControl) {
          swiper.enableMousewheelControl();
        } else if (swiper.mousewheel && swiper.mousewheel.enable) {
          swiper.mousewheel.enable();
        }
      } else {
        if (swiper.disableMousewheelControl) {
          swiper.disableMousewheelControl();
        } else if (swiper.mousewheel && swiper.mousewheel.disable) {
          swiper.mousewheel.disable();
        }
      }
    },
    onDescEnter() {
      this.descScrollPaused = true;
      this.setPageMousewheel(false);
    },
    onDescLeave() {
      this.descScrollPaused = false;
      this.setPageMousewheel(true);
    },
    onDescWheel(e) {
      e.stopPropagation();
      e.preventDefault();
      const { inner, wrap } = this.getDescEls();
      if (!inner || !wrap) return;

      const maxScroll = Math.max(0, inner.scrollHeight - wrap.clientHeight);
      this.descScrollOffset = Math.min(
        maxScroll,
        Math.max(0, this.descScrollOffset + e.deltaY)
      );
      inner.style.transform = `translateY(${-this.descScrollOffset}px)`;
    },
    startDescAutoScroll(retry = 0) {
      this.stopDescAutoScroll();
      const { inner, wrap } = this.getDescEls();
      if (!inner || !wrap) {
        if (retry < 10) {
          this.descScrollRetryTimer = setTimeout(() => {
            this.startDescAutoScroll(retry + 1);
          }, 300);
        }
        return;
      }

      this.descScrollOffset = 0;
      inner.style.transform = "translateY(0)";

      let lastTs = 0;
      let phase = "topPause";
      let pauseRemain = 0.8;
      const speed = 36; // px/s
      const bottomPause = 2;
      const topPause = 0.6;

      this.descScrollRunning = true;
      const step = ts => {
        if (!this.descScrollRunning) return;
        if (!lastTs) lastTs = ts;
        const dt = Math.min((ts - lastTs) / 1000, 0.05);
        lastTs = ts;

        if (!this.descScrollPaused) {
          const maxScroll = Math.max(0, inner.scrollHeight - wrap.clientHeight);
          if (maxScroll > 1) {
            if (phase === "topPause" || phase === "bottomPause") {
              pauseRemain -= dt;
              if (pauseRemain <= 0) {
                if (phase === "bottomPause") {
                  this.descScrollOffset = 0;
                  inner.style.transform = "translateY(0)";
                  phase = "topPause";
                  pauseRemain = topPause;
                } else {
                  phase = "scrolling";
                }
              }
            } else {
              this.descScrollOffset += speed * dt;
              if (this.descScrollOffset >= maxScroll) {
                this.descScrollOffset = maxScroll;
                phase = "bottomPause";
                pauseRemain = bottomPause;
              }
              inner.style.transform = `translateY(${-this.descScrollOffset}px)`;
            }
          }
        }

        this.descScrollRaf = requestAnimationFrame(step);
      };
      this.descScrollRaf = requestAnimationFrame(step);
    },
    stopDescAutoScroll() {
      this.descScrollRunning = false;
      if (this.descScrollRetryTimer) {
        clearTimeout(this.descScrollRetryTimer);
        this.descScrollRetryTimer = null;
      }
      if (this.descScrollResumeTimer) {
        clearTimeout(this.descScrollResumeTimer);
        this.descScrollResumeTimer = null;
      }
      if (this.descScrollRaf) {
        cancelAnimationFrame(this.descScrollRaf);
        this.descScrollRaf = null;
      }
    },
    test() {
      console.log(this.pic1);

      if (!this.pic1) {
        console.log(2222);
        this.pic1 = true;
      }
    }
  }
};
</script>


<style lang="less" scoped>
.content {
  padding-top: 64px;
}
.middle_content {
  background: #f9f9f9;
  // margin-top: 64px;
  min-width: 1200px;
  &-post1 {
    width: 100%;
    min-width: 1200px;
    height: 1016px;
    display: flex;
    justify-content: center;
    align-items: center;
    &-bg {
      width: 578px;
      height: 412px;
      // margin: 0 22px;
      background: #fff;
      margin-top: 34px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 44px;
      cursor: pointer;
      &:last-child {
        margin-right: 0;
      }
      &-flex1 {
        width: 100%;
        height: 550px;
        &-flex {
          width: 1200px;
          margin: 0 auto;
        }
      }
      &-flex {
        width: 1200px;
        height: 550px;
        margin: 0 auto;
        &-flex1 {
          width: 100%;
          height: 550px;
        }
        &-flex {
          display: flex;
          justify-content: space-around;
        }
        &-text {
          width: 411px;
          height: 82px;
        }
        &-text1 {
          width: 258px;
          height: 34px;
        }
        // justify-content: center;
        // align-items: center;
      }
      &-pic {
        width: 558px;
        height: 392px;
      }
    }
    &-bg5 {
      width: 578px;
      height: 412px;
      // margin: 0 22px;
      background: #fff;
      margin-top: 34px;
      padding: 30px;
      box-sizing: border-box;
      font-size: 18px;
      color: #666;
    }
    &-title {
      text-align: center;
      font-size: 36px;
      color: #333;
      margin-bottom: 20px;
    }
      &-desc {
      width: 528px;
      height: 300px;
      font-size: 15px;
      line-height: 24px;
      overflow: hidden;
      &-inner {
        white-space: pre-wrap;
        word-wrap: break-word;
        word-break: break-all;
        will-change: transform;
      }
    }
    &-bg1 {
      width: 318px;
      height: 470px;
      // margin: 0 36px;
      // margin-right: 63px;
      background: #fff;
      margin-top: 44px;
      // &:last-child {
      //   margin-right: 0;
      // }
      &-text {
        width: 262px;
        height: 34px;
      }
      &-pic {
        width: 100%;
        height: 100%;
      }
    }
    &-bg2 {
      width: 1200px;
      height: 850px;
      // background: #fff;
      // margin-top: 110px;
    }
    &-bg3 {
      width: 960px;
      height: 506px;
      margin: 0 auto;
      // background: #fff;
      // margin-top: 296px;
    }
    &-bg4 {
      width: 1000px;
      height: 440px;
      // background: #fff;
      // margin-top: 110px;
      margin: 0 auto;
      margin-bottom: 30px;
      &-text {
        width: 390px;
        height: 34px;
      }
    }
    &-time {
      width: 1200px;
      margin: 0 auto;
      font-size: 16px;
      color: #525252;
      display: flex;
      justify-content: center;
      &-flex {
        display: flex;
      }
      &-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        &-icon {
          width: 10px;
          height: 10px;
          margin-bottom: 16px;
          cursor: pointer;
        }
        &-icon1 {
          width: 23px;
          height: 45px;
          margin-bottom: 16px;
          margin-top: -36px;
        }
      }
      &-line {
        width: 66px;
        height: 1px;
        background: #b8bae0;
        margin-top: 5px;
        margin-left: -13px;
        margin-right: -13px;
      }
    }
  }
}
.btn1 {
  width: 98px;
  height: 154px;
}
.btn2 {
  width: 98px;
  height: 154px;
}
.active {
  color: #181f99;
}
</style>

